<header
  class="ep-header"
  [class.ep-is-light]="light()"
>
  <button
    type="button"
    class="ep-iconbtn"
    [attr.aria-pressed]="pinned()"
    [attr.aria-label]="(pinned() ? 'unpinNavigation' : 'pinNavigation') | translate"
    [attr.title]="(pinned() ? 'unpinNavigation' : 'pinNavigation') | translate"
    (click)="togglePinned()"
  >
    @if (pinned()) {
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"></path>
      </svg>
    } @else {
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
      </svg>
    }
  </button>

  <a
    class="ep-logo"
    routerLink="/dashboards/machines"
    [attr.aria-label]="'eclipseProHome' | translate"
  >
    <img
      src="assets/images/steel/eclipse-pro-logo.svg"
      alt=""
    />
  </a>

  <div class="ep-center">
    <label class="ep-search">
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        ></path>
      </svg>
      <input
        #searchInput
        type="search"
        autocomplete="off"
        spellcheck="false"
        [attr.aria-label]="'searchEclipsePro' | translate"
        aria-describedby="steel-search-shortcut"
        aria-keyshortcuts="Alt+S"
        [placeholder]="'searchPlaceholder' | translate"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        (keydown.escape)="onSearchEscape()"
      />
      <span
        id="steel-search-shortcut"
        class="ep-keys"
        [attr.aria-label]="'searchShortcutHint' | translate"
      >
        <kbd aria-hidden="true">Alt</kbd><kbd aria-hidden="true">S</kbd>
      </span>
    </label>
    <mat-autocomplete
      #auto="matAutocomplete"
      class="steel-search-panel"
      autoActiveFirstOption
      [displayWith]="displayWith"
      (optionSelected)="selectResult($event.option.value)"
    >
      @for (item of results | async; track $index) {
        <mat-option [value]="item">
          <span>{{ item.title }}</span>
          @if (item.subTitle && item.title !== item.subTitle) {
            <span class="ep-search-subtitle"> · {{ item.subTitle }}</span>
          }
        </mat-option>
      } @empty {
        @if (searchTerm.trim() && !isSearching && hasSearched) {
          <mat-option disabled>
            {{ 'searchNoResults' | translate: { term: searchTerm } }}
          </mat-option>
        }
      }
    </mat-autocomplete>
  </div>

  <div class="ep-right">
    <a
      class="ep-iconbtn"
      routerLink="/settings/update"
      [attr.aria-label]="(updateAvailable() ? 'whatsNewUpdateAvailable' : 'whatsNew') | translate"
      [attr.title]="(updateAvailable() ? 'whatsNewUpdateAvailable' : 'whatsNew') | translate"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
        ></path>
      </svg>
      @if (updateAvailable()) {
        <span class="ep-dot"></span>
      }
    </a>
    <a
      class="ep-iconbtn"
      [href]="helpUrl()"
      target="_blank"
      rel="noopener"
      [attr.aria-label]="(helpIsSpecific() ? 'helpForThisPage' : 'helpAndDocumentation') | translate"
      [attr.title]="(helpIsSpecific() ? 'helpForThisPage' : 'helpAndDocumentation') | translate"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
        ></path>
      </svg>
    </a>

    <span
      class="ep-sep"
      aria-hidden="true"
    ></span>

    <button
      type="button"
      class="ep-account ep-account-trigger"
      cdkOverlayOrigin
      #accountOrigin="cdkOverlayOrigin"
      aria-haspopup="dialog"
      [attr.aria-expanded]="accountOpen()"
      [attr.aria-label]="'accountMenu' | translate"
      (click)="toggleAccount()"
    >
      <span
        class="ep-avatar"
        aria-hidden="true"
        >{{ initials() }}</span
      >
      <span class="ep-account-name">
        <b>{{ userName() }}</b>
        @if (plantName()) {
          <span>{{ plantName() }}</span>
        }
      </span>
    </button>

    <button
      type="button"
      class="ep-iconbtn ep-alerts"
      [attr.aria-label]="
        'alertsSummary' | translate: { critical: alerts.criticalAlertsLength, other: otherAlerts }
      "
      [attr.title]="
        'alertsSummary' | translate: { critical: alerts.criticalAlertsLength, other: otherAlerts }
      "
      (click)="openQuickPanel.emit()"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        ></path>
      </svg>
      @if (alerts.alerts.length) {
        <span
          class="ep-badge"
          [class.ep-is-critical]="alerts.criticalAlertsLength > 0"
          aria-hidden="true"
          >{{ alerts.criticalAlertsLength || alerts.alerts.length }}</span
        >
      }
    </button>
  </div>
</header>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="accountOrigin"
  [cdkConnectedOverlayOpen]="accountOpen()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 4 }
  ]"
  (overlayOutsideClick)="onAccountOutsideClick($event)"
  (detach)="closeAccount()"
  (overlayKeydown)="$event.key === 'Escape' && closeAccount()"
>
  <div
    class="ep-account-menu"
    role="dialog"
    [attr.aria-label]="'accountMenu' | translate"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
  >
    <div class="ep-who">
      <span
        class="ep-avatar ep-avatar--lg"
        aria-hidden="true"
        >{{ initials() }}</span
      >
      <span class="ep-who-text">
        <b>{{ userName() }}</b>
        <span>
          {{ role() }}
          @if (role() && plantName()) {
            ·
          }
          {{ plantName() }}
        </span>
      </span>
    </div>

    <div class="ep-facts ep-facts--prefs">
      <app-preferences-picker [compact]="true"></app-preferences-picker>
    </div>

    <div class="ep-facts ep-theme">
      <label class="ep-toggle">
        <span>{{ 'steelTheme' | translate }}</span>
        <input
          type="checkbox"
          role="switch"
          checked
          (change)="turnOffSteel()"
        />
      </label>
      <div class="ep-theme-row">
        <span id="steel-header-style-label">{{ 'headerStyle' | translate }}</span>
        <div
          class="ep-seg"
          role="group"
          aria-labelledby="steel-header-style-label"
        >
          <button
            type="button"
            [attr.aria-pressed]="!light()"
            (click)="setHeaderStyle('steel')"
          >
            {{ 'headerStyleSteel' | translate }}
          </button>
          <button
            type="button"
            [attr.aria-pressed]="light()"
            (click)="setHeaderStyle('light')"
          >
            {{ 'headerStyleLight' | translate }}
          </button>
        </div>
      </div>
    </div>

    <a
      class="ep-item"
      cdkFocusInitial
      [routerLink]="['/settings/users', userName()]"
      (click)="closeAccount()"
      >{{ 'profile' | translate }}</a
    >
    <button
      type="button"
      class="ep-item"
      (click)="openShortcuts()"
    >
      {{ 'keyboardShortcuts' | translate }}
    </button>
    <button
      type="button"
      class="ep-item ep-item--rule"
      (click)="logout()"
    >
      {{ 'logout' | translate }}
    </button>
  </div>
</ng-template>
